module.exports = __webpack_public_path__ + "files/95b4ba3491d3a2d393953c66cb27ac99.svg";